import { render, staticRenderFns } from "./OutgoingPosting.vue?vue&type=template&id=6e6a7636&scoped=true&"
import script from "./OutgoingPosting.vue?vue&type=script&lang=js&"
export * from "./OutgoingPosting.vue?vue&type=script&lang=js&"
import style0 from "./OutgoingPosting.vue?vue&type=style&index=0&id=6e6a7636&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6a7636",
  null
  
)

export default component.exports